import { render, staticRenderFns } from "./RemainderOfEstateAlternative.vue?vue&type=template&id=c9d3f92e&scoped=true"
import script from "./RemainderOfEstateAlternative.vue?vue&type=script&lang=js"
export * from "./RemainderOfEstateAlternative.vue?vue&type=script&lang=js"
import style0 from "./RemainderOfEstateAlternative.vue?vue&type=style&index=0&id=c9d3f92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d3f92e",
  null
  
)

export default component.exports